export { default } from "./RemoveAcademyDialogContainer";
